import { observer } from 'mobx-react';
import { FC, ReactElement } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import ModalActionButton from 'src/view/components/Controls/Modal/ModalActionButton/ModalActionButton';
import { getTranslate } from '~/utils/helpers';
import { IAllBranchesModalItem } from '~/view/containers/Modals/AllBranchesModal/AllBranchesModal';
import { IBranchesModalItem } from '~/view/containers/Modals/BranchesModal/BranchesModal';

interface IProps {
  searchValue: string;
  selectedBranches?: IBranchesModalItem[] | IAllBranchesModalItem[];
  selectAll: () => void;
  deselectAll: () => void;
  isMulti: boolean;
  hideSelectAllButtonWhenSearch?: boolean;
  hideSelectAllButton?: boolean;
  hideDeselectAllButton?: boolean;
}

export const BranchesModalHeaderControls: FC<IProps> = observer((props: IProps): ReactElement | null => {
  if (props.isMulti) {
    return (
      <div className="d-flex flex-row gap-20">
        {props.hideSelectAllButton || (props.searchValue && props.hideSelectAllButtonWhenSearch) ? null : (
          <ModalActionButton title={localeStore.t('select_all')} onClick={props.selectAll} />
        )}

        {props.hideDeselectAllButton ? null : <ModalActionButton title={localeStore.t('deselect_all')} onClick={props.deselectAll} />}
      </div>
    );
  }

  if (props.selectedBranches?.length) {
    return (
      <div className="d-flex flex-row align-items-center">
        <p className="family-medium text-size-14">{localeStore.t('selected')}</p>
        <p className="custom-modal-header-selected-item-title family-semibold text-size-14 mx-3">{getTranslate(props.selectedBranches[0]?.name)}</p>
        <ModalActionButton title={localeStore.t('deselect')} onClick={props.deselectAll} type="some" />
      </div>
    );
  }

  return null;
});
